import { FRAME_THEME_COLOR } from '@nandosaus/constants';
import { observer } from 'mobx-react';
import { useCompetition, useRootStore } from '@nandosaus/state-management';
import PropTypes from 'prop-types';

import { Alert } from '../../components/alert';
import { BackgroundFrame } from '../../components/frames/background-frame';
import { Container, Flex } from '../../components/grid';
import { Icon } from '../../components/icons';
import { Layout } from '../../components/layout';
import { SpinToWinContent } from '../../components/spin-to-win-content';
import { useIsClient } from '../../hooks/use-is-client';

const { TEAL } = FRAME_THEME_COLOR;

const SpinToWin = ({ title }) => {
  const { MemberStore } = useRootStore();
  const { loading: isLoadingMember, profile } = MemberStore;
  const { isLoading: isLoadingCompetition } = useCompetition();
  const isClient = useIsClient();
  const isLoading = !isClient || isLoadingCompetition || isLoadingMember;

  return (
    <Layout title={title}>
      <Flex height="100%" flexDirection="column" overflow="hidden">
        {!isLoading && !profile && (
          <Container flexDirection="column" flex={1} my={1}>
            <Alert
              icon={<Icon name="bell" fill="alertInfo" stroke="none" mr="0.5rem" minHeight="24px" minWidth="24px" />}
              heading="Don’t close your browser session."
              type="info"
              mt={1}
            >
              Your spins are only available with the current browser session.
            </Alert>
          </Container>
        )}
        <BackgroundFrame showFireIcon padding={0} variant={TEAL}>
          <SpinToWinContent />
        </BackgroundFrame>
      </Flex>
    </Layout>
  );
};

SpinToWin.propTypes = { title: PropTypes.string };

SpinToWin.defaultProps = { title: undefined };

export function getStaticProps() {
  return { props: { title: 'Spin to Win!' } };
}

export default observer(SpinToWin);
